<template>
  <div class="container mt-2">
    <div
      v-if="$apolloData.queries.bills.loading
        && $apolloData.queries.precios.loading"
      class="text-center text-muted vertical-centered vc-75vh"
    >
      <font-awesome-icon
        :icon="['fas', 'circle-notch']"
        class="fa-spin fa-5x my-4"
      />
      <small
        class="d-block"
      >
        CARGANDO
      </small>
    </div>
    <div v-else>
      <header class="h3-responsive text-center font-weight-bold my-3">
        Pagos
      </header>
      <div class="filter-container">
        <header class="font-weight-bold text-center">
          Consultar pagos
        </header>
        <form @submit.prevent="filterAndSearch">
          <div class="row justify-content-center">
            <div class="col-12 col-sm-6 col-md-4">
              <mdb-input
                v-model="searchBy.date.from"
                type="date"
                label="Desde"
                class="my-2 outline-date"
                outline
              />
            </div>
            <div class="col-12 col-sm-6 col-md-4">
              <mdb-input
                v-model="searchBy.date.to"
                type="date"
                label="Hasta"
                class="my-2 outline-date"
                outline
              />
            </div>
            <mdb-btn
              type="button"
              class="col-12 col-md-auto mx-0 px-3"
              icon="sliders-h"
              flat
              dark-waves
              @click="showAdvancedOptions = !showAdvancedOptions;
                      searchBy.status = ''; searchBy.name = '';"
            >
              Opciones avanzadas
            </mdb-btn>
          </div>
          <div
            v-if="showAdvancedOptions"
            class="row justify-content-center"
          >
            <div class="col-12 col-md-5 col-lg-4">
              <div class="my-2 md-form md-outline outline-select">
                <select
                  id="select-estatus"
                  v-model="searchBy.status"
                  class="custom-select"
                >
                  <option
                    class="d-none"
                    disabled
                    value=""
                  >
                    Selecciona
                  </option>
                  <option
                    v-for="(status, key) in statusTranslate"
                    :key="key"
                    :value="key"
                  >
                    {{ status }}
                  </option>
                </select>
                <label
                  for="select-estatus"
                  :class="searchBy.status && searchBy.status.length
                    ? 'label-active' : 'label-inactive'"
                >
                  Estatus
                </label>
              </div>
            </div>
            <div class="col-12 col-md-6">
              <mdb-input
                id="input-name"
                v-model="searchBy.name"
                class="my-2"
                label="Nombre"
                placeholder="Escribe un nombre"
                outline
              />
            </div>
          </div>
          <div class="row justify-content-center">
            <BtnLoader
              btn-color="success"
              btn-classes="px-3"
              btn-icon="search"
              :btn-disabled="btnDisabled"
              btn-title="Consultar"
              btn-type="submit"
            />
            <mdb-btn
              type="button"
              class="px-3"
              dark-waves
              flat
              :icon="btnDisabled ? 'circle-notch' : 'tags'"
              icon-class="fa-lg"
              :disabled="btnDisabled"
              @click="filterAndSearch('all')"
            >
              Todas las Facturas
            </mdb-btn>
          </div>
        </form>
      </div>
      <div v-if="billsWPrices && billsWPrices.length">
        <ul class="row justify-content-around list-unstyled">
          <li
            v-for="(bill, index) in billsWPrices"
            :key="index"
            class="col-12 col-md-6 col-xl-4 my-2"
          >
            <div class="card p-3">
              <header>
                <mdb-badge
                  class="float-right ml-2 z-depth-0"
                  :color="billStatusBadgeColor(bill.status)"
                  pill
                >
                  {{ statusTranslate[bill.status] }}
                </mdb-badge>
                {{ bill.owner.fname }} {{ bill.owner.mname }}
                {{ bill.owner.lname }} {{ bill.owner.llname }}
              </header>
              <!-- Planes / Servicios incluidos -->
              <div
                v-if="bill.items && bill.items.length > 1"
                class="my-2 border-top border-bottom py-1"
              >
                <small
                  class="d-block text-muted text-uppercase
                    font-weight-bold mb-1"
                >
                  Conceptos incluidos ({{ bill.items.length }})
                </small>
                <ul class="list-unstyled mb-0">
                  <li
                    v-for="(it, itIdx) in bill.items"
                    :key="itIdx"
                    class="d-flex justify-content-between
                    align-items-center fs-09 py-1"
                  >
                    <span>
                      {{ it.name }}
                      <small
                        v-if="it.quantity && it.quantity > 1"
                        class="badge badge-light ml-1"
                      >
                        x{{ it.quantity }}
                      </small>
                    </span>
                    <span
                      v-if="it.amount"
                      class="text-muted font-weight-bold ml-2"
                    >
                      {{ it.amount }} {{ bill.symbol || '' }}
                    </span>
                  </li>
                </ul>
              </div>
              <small
                v-else-if="bill.items && bill.items.length === 1"
                class="d-block text-muted text-uppercase mt-n1"
              >
                Plan {{ bill.items[0].name }}
              </small>
              <small
                v-else-if="bill.substype && bill.substype.name"
                class="d-block text-muted text-uppercase mt-n1"
              >
                Plan {{ bill.substype.name }}
              </small>
              <div class="row justify-content-between mt-1 fs-09">
                <div
                  v-if="bill.substypeFormat && bill.substypeFormat.price
                    && (!bill.items || bill.items.length <= 1)"
                  class="col-auto mt-1 fs-inherit"
                >
                  {{ bill.substypeFormat.price.amount }}
                  {{ bill.substypeFormat.price.symbol }}
                  <small class="d-block mt-n1 text-muted text-uppercase">
                    Precio del plan
                  </small>
                </div>
                <div class="col-auto mt-1 fs-inherit">
                  {{ bill.total }} {{ bill.symbol || '' }}
                  <small class="d-block mt-n1 text-muted text-uppercase">
                    Total Factura
                  </small>
                </div>
                <div
                  v-if="bill.quantity && (!bill.items
                    || bill.items.length <= 1)"
                  class="col-auto mt-1 fs-inherit"
                >
                  {{ bill.quantity }}
                  <small class="d-block mt-n1 text-muted text-uppercase">
                    Cantidad
                  </small>
                </div>
                <div class="col-auto mt-1 fs-inherit">
                  {{ bill.date.formatted }}
                  <small class="d-block mt-n1 text-muted text-uppercase">
                    Fecha
                  </small>
                </div>
              </div>
              <div
                v-if="bill.payments.length"
                class="row justify-content-between mt-1 fs-09"
              >
                <small class="col-12 mt-2 mb-n1 text-uppercase">
                  Detalles del último pago
                </small>
                <div class="col-auto mt-1 fs-inherit">
                  {{ bill.payments[bill.payments.length - 1].amount }}
                  {{ bill.payments[bill.payments.length - 1].symbol }}
                  <small class="d-block mt-n1 text-muted text-uppercase">
                    Monto pagado
                  </small>
                </div>
                <div class="col-auto mt-1 fs-inherit">
                  {{ bill.payments[bill.payments.length - 1].currency }}
                  <small class="d-block mt-n1 text-muted text-uppercase">
                    Moneda
                  </small>
                </div>
                <div class="col-auto mt-1 fs-inherit">
                  {{ bill.payments[bill.payments.length - 1].reference }}
                  <small class="d-block mt-n1 text-muted text-uppercase">
                    Referencia
                  </small>
                </div>
                <div class="col-auto mt-1 fs-inherit">
                  {{ bill.payments[bill.payments.length - 1].toAccount }}
                  <small class="d-block mt-n1 text-muted text-uppercase">
                    Cuenta receptora
                  </small>
                </div>
                <small
                  class="col-12 text-uppercase text-muted font-weight-bold"
                >
                  Tiene {{ bill.payments.length }}
                  Pago{{ bill.payments.length > 1 ? 's' : '' }}
                  realizado{{ bill.payments.length > 1 ? 's' : '' }}
                </small>
              </div>
              <div class="row justify-content-end mx-0 mb-n1">
                <mdb-btn
                  v-if="bill.payments.length"
                  flat
                  dark-waves
                  class="col-6 m-0 p-2"
                  icon="list"
                  icon-class="fa-2x"
                  type="button"
                  title="Pagos realizados"
                  @click="paymentsDetails(bill)"
                />
                <div
                  class="col-6 px-2 our-checkbox big-icon-style text-center"
                  title="Seleccionar pago"
                >
                  <input
                    :id="`checkbx-solmod-${index}`"
                    v-model="billsId"
                    type="checkbox"
                    :value="bill.id"
                  >
                  <label
                    :for="`checkbx-solmod-${index}`"
                    class="mb-0 w-100"
                  />
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
      <div
        v-else
        class="d-flex flex-column flex-lg-row align-items-center
          justify-content-center text-muted my-4 mt-4"
      >
        <font-awesome-icon
          :icon="['fas', 'file-invoice']"
          class="my-2 fa-7x"
        />
        <p class="h2-responsive text-center px-4">
          <span class="d-block fs-inherit">
            No tienes Pagos
          </span>
          <span class="d-block fs-inherit">
            por confirmar
          </span>
        </p>
      </div>
      <div class="buttons-flotantes">
        <mdb-btn
          type="button"
          class="rounded-btn"
          color="primary"
          icon="plus"
          icon-class="fa-3x"
          title="Crear pago"
          @click="showCreatePayment = true"
        />
        <template v-if="billsWPrices && billsWPrices.length">
          <mdb-btn
            type="button"
            class="rounded-btn"
            color="danger"
            :icon="btnDisabled ? 'circle-notch' : 'ban'"
            :icon-class="btnDisabled ? 'fa-3x fa-spin' : 'fa-3x'"
            :title="btnDisabled ? 'Cargando...' : 'Cancelar pago(s)'"
            :disabled="btnDisabled"
            @click="billUpdate('Rejected')"
          />
          <mdb-btn
            type="button"
            class="rounded-btn"
            color="success"
            :icon="btnDisabled ? 'circle-notch' : 'check'"
            :icon-class="btnDisabled ? 'fa-3x fa-spin' : 'fa-3x'"
            :title="btnDisabled ? 'Cargando...' : 'Aprobar pago(s)'"
            :disabled="btnDisabled"
            @click="billUpdate('Approved')"
          />
        </template>
      </div>
    </div>
    <AlertaMsj :alerta-msj="alertaMsj" />
    <!-- Modal cancelar pago -->
    <mdb-modal
      centered
      elegant
      :show="showCancelReason"
      @close="showCancelReason = false"
    >
      <mdb-modal-header>
        <mdb-modal-title>
          Motivo de la cancelación
        </mdb-modal-title>
      </mdb-modal-header>
      <mdb-modal-body>
        <mdb-input
          id="motivo"
          v-model="motivo"
          label="Cuéntanos tu motivo"
          type="textarea"
          :rows="5"
          class="my-1"
          outline
        />
        <div class="row justify-content-center">
          <mdb-btn
            color="success"
            class="px-3"
            icon="paper-plane"
            title="Agregar motivo"
            :disabled="btnDisabled"
            @click="enviarMotivo=true; billUpdate('Rejected')"
          >
            Enviar motivo
          </mdb-btn>
        </div>
      </mdb-modal-body>
    </mdb-modal>
    <!-- Modal detalles de los pagos -->
    <mdb-modal
      centered
      elegant
      :show="showPaymentsDetails"
      @close="closePaymentsDetails"
    >
      <mdb-modal-header>
        <mdb-modal-title>
          Detalles de la Factura
        </mdb-modal-title>
      </mdb-modal-header>
      <mdb-modal-body>
        <!-- Detalle de planes / items contratados -->
        <div
          v-if="billSelectedItems && billSelectedItems.length"
          class="mb-3"
        >
          <small
            class="d-block text-uppercase text-muted font-weight-bold mb-2"
          >
            Planes y servicios solicitados ({{ billSelectedItems.length }})
          </small>
          <div class="table-responsive">
            <table class="table table-sm table-striped mb-0">
              <thead class="thead-light">
                <tr>
                  <th>Plan / Servicio</th>
                  <th class="text-center">
                    Cantidad
                  </th>
                  <th class="text-right">
                    Monto
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(item, itemIndex) in billSelectedItems"
                  :key="itemIndex"
                >
                  <td class="align-middle">
                    {{ item.name }}
                  </td>
                  <td class="text-center align-middle">
                    {{ item.quantity || 1 }}
                  </td>
                  <td class="text-right align-middle">
                    <span v-if="item.amount">
                      {{ (item.amount * (item.quantity || 1)).toFixed(2) }}
                      {{ selectedBill && selectedBill.symbol
                        ? selectedBill.symbol : '' }}
                      <small
                        v-if="item.quantity && item.quantity > 1"
                        class="d-block text-muted"
                      >
                        ({{ item.amount }} c/u)
                      </small>
                    </span>
                    <span v-else>
                      -
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <small
          v-if="billSelectedPayments && billSelectedPayments.length"
          class="d-block text-uppercase text-muted font-weight-bold mb-2"
        >
          Transacciones realizadas ({{ billSelectedPayments.length }})
        </small>
        <div
          v-for="payment in billSelectedPayments"
          :key="payment.reference"
          class="payments-before-line"
        >
          <mdb-badge
            class="float-right z-depth-0 mr-sm-4"
            :color="billStatusBadgeColor(payment.status)"
            pill
          >
            {{ statusTranslate[payment.status] }}
          </mdb-badge>
          <p class="mb-2">
            <small class="d-block mb-n1 text-muted text-uppercase">
              Fecha
            </small>
            {{ payment.date.formatted }}
          </p>
          <div class="row justify-content-between">
            <p class="col-auto col-sm-6 mb-2">
              <small class="d-block mb-n1 text-muted text-uppercase">
                Monto pagado
              </small>
              {{ payment.amount }}
              {{ payment.symbol }}
            </p>
            <p class="col-auto col-sm-6 mb-2">
              <small class="d-block mb-n1 text-muted text-uppercase">
                Moneda
              </small>
              {{ payment.currency }}
            </p>
            <p class="col-auto col-sm-6 mb-2">
              <small class="d-block mb-n1 text-muted text-uppercase">
                Metodo de pago
              </small>
              {{ payment.method }}
            </p>
            <p class="col-auto col-sm-6 mb-2">
              <small class="d-block mb-n1 text-muted text-uppercase">
                Referencia
              </small>
              {{ payment.reference }}
            </p>
            <p class="col-auto col-sm-6 mb-2">
              <small class="d-block mb-n1 text-muted text-uppercase">
                Cuenta receptora
              </small>
              {{ payment.toAccount }}
            </p>
            <p class="col-auto col-sm-6 mb-2">
              <small class="d-block mb-n1 text-muted text-uppercase">
                Cuenta proveniente
              </small>
              {{ payment.fromBank }}
            </p>
          </div>
        </div>
        <div class="row justify-content-center">
          <mdb-btn
            color="blue-grey"
            class="px-3"
            icon="times"
            @click="closePaymentsDetails"
          >
            Cerrar
          </mdb-btn>
        </div>
      </mdb-modal-body>
    </mdb-modal>
    <ModalCrearPago
      :show="showCreatePayment"
      @close="showCreatePayment = false"
      @success="showCreatePayment = false; filterAndSearch('all')"
    />
  </div>
</template>

<script>
import {
  mdbInput,
  mdbBtn,
  mdbBadge,
  mdbModal,
  mdbModalHeader,
  mdbModalBody,
  mdbModalTitle,
} from 'mdbvue';
import gql from 'graphql-tag';
import AlertaMsj from '@/components/AlertaMsj.vue';
import BtnLoader from '@/components/customButtons/BtnLoader.vue';
import ModalCrearPago from '@/components/ModalCrearPago.vue';
import {todayDate} from '@/utils/validations.js';
import paymentsToAmiiWaitingGql from '@/graphql/paymentsToAmiiWaiting.gql';
import amiiSubsGql from '@/graphql/amiiSubs.gql';
import paymentsToAmiiProcessGql from '@/graphql/paymentsToAmiiProcess.gql';

export default {
  name: 'PagosPorConfirmar',
  components: {
    mdbInput,
    mdbBtn,
    mdbBadge,
    mdbModal,
    mdbModalBody,
    mdbModalHeader,
    mdbModalTitle,
    AlertaMsj,
    BtnLoader,
    ModalCrearPago,
  },
  data() {
    return {
      searchBy: {
        date: {
          from: '',
          to: '',
        },
        status: '',
        name: '',
      },
      alertaMsj: {
        content: '',
      },
      billsId: [],
      motivo: '',
      btnDisabled: false,
      statusTranslate: {
        Checking: 'En revisión',
        Rejected: 'Rechazado',
        Approved: 'Aprobado',
        Pending: 'Pendiente',
      },
      showCancelReason: false,
      enviarMotivo: false,
      showPaymentsDetails: false,
      billSelectedPayments: [],
      billSelectedQuantity: 0,
      billSelectedItems: [],
      selectedBill: null,
      bills: [],
      precios: [],
      showAdvancedOptions: false,
      variablesApollo: {
        start: '',
        end: '',
      },
      skipFacturasStart: true,
      msjToQuery: '',
      showCreatePayment: false,
    };
  },
  computed: {
    billsWPrices: function() {
      if (
        !this.bills ||
        !this.bills.length
      ) {
        return [];
      }
      return this.bills.map((bill) => {
        const valueOfBill = {...bill};
        let returnPrice = null;
        if (
          this.precios &&
          this.precios.length &&
          valueOfBill.substype &&
          valueOfBill.substype.id
        ) {
          for (const precio of this.precios) {
            if (precio.types) {
              const matchedType = precio.types.find(
                  (type) => type.id == valueOfBill.substype.id,
              );
              if (matchedType && matchedType.prices) {
                const matchedPrice = matchedType.prices.find(
                    (price) =>
                      price.Currency &&
                      price.Currency.symbol == valueOfBill.symbol,
                );
                if (matchedPrice) {
                  returnPrice = matchedPrice;
                  break;
                }
              }
            }
          }
        }
        if (returnPrice) {
          valueOfBill.substypeFormat = {
            price: returnPrice,
          };
        }
        return valueOfBill;
      });
    },
  },
  created() {
    const dateNow = todayDate().split('-');
    if (dateNow[2] > 1) {
      this.searchBy.date.from = `${dateNow[0]}-${dateNow[1]}-01`;
      this.searchBy.date.to = todayDate();
    } else {
      this.searchBy.date.from = todayDate();
      this.searchBy.date.to = todayDate();
    }
    this.variablesApollo = {
      start: this.searchBy.date.from,
      end: this.searchBy.date.to,
    };
    this.skipFacturasStart = false;
  },
  methods: {
    billStatusBadgeColor(status) {
      switch (status) {
        case 'Checking':
          return 'default';
        case 'Rejected':
          return 'danger';
        case 'Approved':
          return 'success';
        default:
          return 'secondary';
      }
    },
    paymentsDetails(bill) {
      this.showPaymentsDetails = true;
      this.billSelectedPayments = bill.payments || [];
      this.billSelectedQuantity = bill.quantity;
      this.billSelectedItems = bill.items || [];
      this.selectedBill = bill;
    },
    closePaymentsDetails() {
      this.showPaymentsDetails = false;
      this.billSelectedPayments = [];
      this.billSelectedQuantity = 0;
      this.billSelectedItems = [];
      this.selectedBill = null;
    },
    todayDate() {
      return (new Date()).toISOString().split('T')[0];
    },
    filterAndSearch(all) {
      let variablesToQuery;
      this.alertaMsj.content = '';
      if (all == 'all') {
        this.searchBy = {
          date: {
            from: '',
            to: '',
          },
          status: '',
          name: '',
        };
        variablesToQuery = {};
      } else {
        variablesToQuery = {
          start: this.searchBy.date.from,
          end: this.searchBy.date.to,
          status: this.searchBy.status,
          fullname: this.searchBy.name,
        };
        if (!this.searchBy.date.from || !this.searchBy.date.to) {
          return this.alertaMsj = {
            content: 'Debe ingresar un rango de fechas',
            type: 'warning',
          };
        }
        if (this
            .rangeDateValid(this.searchBy.date.from, this.searchBy.date.to)) {
          this.btnDisabled = true;
          if (this.searchBy.status == '' && this.searchBy.name == '') {
            delete variablesToQuery.status;
            delete variablesToQuery.fullname;
            this.msjToQuery = 'fecha';
          } else if (this.searchBy.status != '' && this.searchBy.name == '') {
            delete variablesToQuery.fullname;
            this.msjToQuery = 'estatus';
          } else if (this.searchBy.name.length < 3) {
            this.btnDisabled = false;
            return this.alertaMsj = {
              content: 'Escriba un nombre con mínimo de 3 caracteres',
              type: 'warning',
            };
          } else if (this.searchBy.status != '' && this.searchBy.name != '') {
            this.msjToQuery = 'nombre';
          } else if (this.searchBy.status == '' && this.searchBy.name != '') {
            delete variablesToQuery.status;
            this.msjToQuery = 'nombre';
          }
        } else {
          return this.alertaMsj = {
            content: 'La fecha inicial debe ser menor a la fecha final',
            type: 'warning',
          };
        }
      }
      this.$apollo
          .query({
            query: gql`
            ${paymentsToAmiiWaitingGql}
          `,
            variables: variablesToQuery,
            update: (data) => data.paymentsToAmiiWaiting,
            fetchPolicy: 'no-cache',
          })
          .then((res) => {
            this.bills = res.data.paymentsToAmiiWaiting;
            this.billsId = [];
            return this.btnDisabled = false;
          })
          .catch((error) => {
            this.btnDisabled = false;
            return (this.alertaMsj = {
              content: `Hubo un error al filtrar por ${this.msjToQuery}`,
              type: 'danger',
            });
          });
    },
    rangeDateValid(condStart, condEnd) {
      const start = new Date(condStart);
      const end = new Date(condEnd);
      if (start < end) {
        return true;
      } else {
        return false;
      }
    },
    billUpdate(methodCase) {
      if (methodCase != 'Rejected' && methodCase != 'Approved') return;
      if (this.billsId.length < 1) {
        return (this.alertaMsj = {
          content: `Selecciona una factura antes de continuar`,
          type: 'warning',
        });
      }
      const variablesToQuery = {
        billsID: this.billsId,
        bill: {
          status: methodCase,
          note: this.motivo,
        },
      };
      this.msjToQuery= {
        toThen: 'Factura ha sido rechazada satisfactoriamente',
        toDefault: 'Hubo un error al rechazar la factura',
        toCatch: 'Hubo un error al enviar la factura',
      };
      if (methodCase == 'Rejected') {
        this.showCancelReason = true;
        if (this.enviarMotivo && !this.motivo) {
          return this.alertaMsj = {
            content: 'Ingresa un motivo para rechazar la factura',
            type: 'warning',
          };
        }
        if (this.enviarMotivo && this.motivo.length < 4) {
          return this.alertaMsj = {
            content: 'Ingresa al menos 4 caracteres',
            type: 'warning',
          };
        } if (!(this.showCancelReason && this.enviarMotivo &&
              this.motivo.length >= 4)) return;
      } else {
        delete variablesToQuery.bill.note;
        this.msjToQuery.toThen= 'La factura ha sido aprobada '+
        ' satisfactoriamente';
        this.msjToQuery.toDefault= 'Hubo un error al aprobar la factura';
      }
      this.btnDisabled = true;
      this.$apollo
          .mutate({
            mutation: gql`
            ${paymentsToAmiiProcessGql}
          `,
            variables: variablesToQuery,
          })
          .then((res) => {
            const msg = res.data.paymentsToAmiiProcess.msg;
            switch (msg) {
              case 'success':
                this.bills = this.bills.filter((e) => {
                  return !this.billsId.includes(e.id);
                });
                if (methodCase == 'Rejected') {
                  this.showCancelReason = false;
                  this.enviarMotivo = false;
                  this.motivo = '';
                }
                this.billsId = [];
                this.btnDisabled = false;
                this.alertaMsj = {
                  content: this.msjToQuery.toThen,
                  type: 'success',
                };
                break;
              default:
                this.btnDisabled = false;
                this.alertaMsj = {
                  content: this.msjToQuery.toDefault,
                  type: 'danger',
                };
                break;
            }
            this.btnDisabled = false;
          })
          .catch((error) => {
            this.btnDisabled = false;
            return (this.alertaMsj = {
              content: this.msjToQuery.toCatch,
              type: 'danger',
            });
          });
    },
  },
  apollo: {
    bills() {
      return {
        query: gql`
          ${paymentsToAmiiWaitingGql}
        `,
        variables() {
          return {
            start: this.variablesApollo.start,
            end: this.variablesApollo.end,
          };
        },
        skip() {
          return this.skipFacturasStart;
        },
        update: (data) => data.paymentsToAmiiWaiting,
        fetchPolicy: 'no-cache',
      };
    },
    precios() {
      return {
        query: gql`
          ${amiiSubsGql}
        `,
        update: (data) => data.amiiSubs,
        fetchPolicy: 'no-cache',
      };
    },
  },
};
</script>
<style lang="scss">
.buttons-flotantes {
  bottom: 1rem;
  display: flex;
  flex-direction: column;
  position: fixed;
  right: 1rem;
  transition: right 0.8s ease;

  @media (min-width: 1300px) {
    bottom: 2rem;
    right: 5%;
  }
  @media (min-width: 1500px) {right: 9%;}
  @media (min-width: 1700px) {right: 14%;}
  @media (min-width: 2000px) {right: 21%;}

  .rounded-btn {
    border-radius: 50%;
    padding: .75rem .5rem;;
  }
}

.our-checkbox.big-icon-style label::before {
  color: inherit;
  font-size: 1.8rem;
}
.payments-before-line {
  padding: .75rem 0 0;

  &:first-child {padding-top: 0;}
  & + .payments-before-line {border-top: 1px solid #e3eaf1;}
}
</style>
